<template>
<div class="textcontainer">
<contact></contact>
</div>
</template>

<script>
import contact from '../assets/md/contact.md';
// this is just a shell component for the markdown now, in case I want to directly mess with non-markdown parts later.

export default {
     components: {contact}
}

</script>



// WEBPACK FOOTER //
// contact.vue?3e5df0a9